import React from "react";
import { useNavigate } from "react-router-dom";
import MobileServiceHeader from "./component/MobileServiceHeader";
import ServiceMobileSingleLotAnimation from "./component/ServiceMobileSingleLotAnimation";

function ServiceMobileLiveView({paidEmdOfferData}) {
  const navigate = useNavigate();
 

  return (
    <div className="full-width flex column gap-1 p-1">
      <span className={`valign-wrapper gap-1`}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>

        <h4>Live room</h4>
      </span>
      <MobileServiceHeader singleAuctionData={paidEmdOfferData?.auction} />
      <ServiceMobileSingleLotAnimation singleAuctionData={paidEmdOfferData}/>
    </div>
  );
}

export default ServiceMobileLiveView;
